import { IBeneficiary, IContactPerson, ILegalPersonSaveParam, ILicenseSaveParam } from '@core/main/src/components';
import { EAccountType, EAgentLevel, EBankType, ECompanyType, EPayeeIdType, EPaymentChannel, IPageParam } from './common';
import { ESystemType } from '@core/api';
import { isNull } from '@core/tools';
import { IYibaoBaseInfo } from './yibao';
import { IPaymentAccount } from './air-splitting/paymentAccount';
import { IMyWalletDetail } from './lianlian';

export interface IFinanceMonthEndParam extends IPageParam {
  /** 服务商名称 */
  zsServerId: string;
}

export interface IFinanceServerAccountParam extends IPageParam {
  /** 服务商编号 */
  serverNo: string;
  /** 服务商名称 */
  serverName: string;
  /** 	招行账号 */
  bankAccount: string;
}

export interface IFinanceServerAccount {
  zsServerId: number;
  /** 服务商编号 */
  serverNo: string;
  /** 服务商名称 */
  serverName: string;
  /** 	招行账号 */
  bankAccount: string;
  /** 账户余额 */
  sumBalance: number;
  /** 默认子单元余额 */
  defaultBalance: number;
  /** 正常状态子单元数 */
  count: number;
  /** 招商子单元Id */
  accountId: number;
}

export interface IFinanceSubunitParam extends IPageParam {
  /** 名称 */
  bizName: string;
  /** 编号 */
  bizNo: string;
  /** 代理商名称 */
  agentName?: string;
  /** 关联代理商名称 */
  relatedAgentName?: string;
  /** 所属服务商 */
  serverName?: string;
  /** 所属服务商ID */
  zsServerId?: number;
  /** 子单元账户类型 */
  bizType?: 'AGENT' | 'COMPANY';
  /** 代理商级别 */
  levelType?: EAgentLevel;
}

export const bizTypeLabel = {
  AGENT: '代理商',
  COMPANY: '企业',
};

export interface IFinanceSubunit {
  unitId: number;
  /** 名称 */
  bizName: string;
  /** 编号 */
  bizNo: string;
  /** 业务id */
  bizId?: number;
  /** 子单元编号 */
  unitNo: string;
  /** 子单元余额 */
  balance: number;
  /**
   * 子单元状态 1开启，0关闭
   * @description {@link ESubunitStatus}
   */
  enabled: ESubunitStatus;
  /**
   * 入账状态 1-允许入账，0-禁止入账
   * @description {@link EFinanceDepositStatus}
   */
  depositFlag: EFinanceDepositStatus;
  /** 所属招行账号 */
  bankAccount: string;
  /** 所属服务 */
  serverName: string;
  showDeleteUnit?: boolean;
  showOnDepositFlag?: boolean;
  showOffDepositFlag?: boolean;
  /** 代理商ID */
  agentId?: number;
  /** 代理商名称 */
  agentName?: string;
  /** 开户行 */
  openingBank?: string;
  /** 收款户名 */
  accountName?: string;
  /** 收款账号 */
  accountNo?: string;
  /** 企业名称 */
  companyName?: string;
}

export enum EFinanceDepositStatus {
  /** 允许入账 */
  Enabled = 1,
  /** 禁止入 */
  Disabled = 0,
}

export const financeDepositStatusLabel = {
  [EFinanceDepositStatus.Enabled]: '已开启',
  [EFinanceDepositStatus.Disabled]: '已关闭',
};

export const financeDepositStatusStyle = {
  [EFinanceDepositStatus.Enabled]: 'success',
  [EFinanceDepositStatus.Disabled]: 'danger',
};

export enum ESubunitStatus {
  /** 已开启 */
  Opened = 1,
  /** 已关闭 */
  Closed = 0,
}

export const subunitStatusLabel = {
  [ESubunitStatus.Opened]: '已开启',
  [ESubunitStatus.Closed]: '已关闭',
};

export const subunitStatusStyle = {
  [ESubunitStatus.Opened]: 'success',
  [ESubunitStatus.Closed]: 'danger',
};

export interface IReconiliationListParam extends IPageParam {
  /** 开始月份 */
  startTime: string;
  /** 结束月份 */
  endTime: string;
}

export interface IConfirmReconciliationParam {
  /** 服务商招生银行Id */
  zsServerId: number;
  /** 对账月份 */
  month: string;
  sqrnbr: string;
  bchnbr: string;
  barcod: string;
  barseq: string;
  eacnbr: string;
  actseq: string;
}

export interface IReconiliationList extends IConfirmReconciliationParam {
  /** 服务商名称 */
  serverName: string;
  /** 服务商编号 */
  serverNo: string;
  /** 招行账号 */
  bankAccount: string;
  /** 月底余额 */
  monthBalance: number;
  /** 客户处理状态 1待经办 2待复核 3复合通过 */
  checkStatus: 1 | 2 | 3;
  /** 对账状态 1已生成数据 3对账中 5对账完成 */
  status: 1 | 3 | 5;
}

export const checkStatusLabel = {
  1: '待经办',
  2: '待复核',
  3: '复核通过',
};

export const reconiliationStatusLabel = {
  1: '已生成数据',
  3: '对账中',
  5: '对账完成',
};

export interface ISubunitPayerItem {
  /** 付款方id */
  payerId: number;
  /** 记账子单元表id */
  unitId: number;
  /** 关联付款方账号 */
  payAccount: string;
  /** 非关联付款方入账方式 Y:非关联账号入对应记账子单元账N:非关联账号入默认记账子单元账R:非关联账号拒绝入账默认Y */
  accountType: string;
  /** 状态 (0:失败,1:成功) */
  payStatus: number;
}

export enum ESubunitPayStatus {
  /** 绑定成功 */
  Succeed = 1,
  /** 绑定失败 */
  Failed = 0,
}

export const subunitPayStatusLabel = {
  [ESubunitPayStatus.Succeed]: '绑定成功',
  [ESubunitPayStatus.Failed]: '绑定失败',
};

export const subunitPayStatusStyle = {
  [ESubunitPayStatus.Succeed]: 'success',
  [ESubunitPayStatus.Failed]: 'danger',
};

export const subunitAccountStatusLabel = {
  Y: '入对应记账子单元账',
  N: '入默认记账子单元账',
  R: '拒绝入账',
};

export interface ISubunitWithDrawItem {
  /** 提现账号id,修改提现账号时传入 */
  withdrawId: number;
  /** 记账子单元表id */
  unitId: number;
  /** 提现账号 */
  withdrawAccount: string;
  /** 是否是招商银行（0：招商银行，1：非招商银行） */
  isZs: 0 | 1;
  /** 开户行名称 */
  bankName: string;
  /** 开户行地址 */
  bankAddress: string;
  provinceCode: string;
  cityCode: string;
  areaCode: string;
}

export interface IServerProvider {
  /** 服务商ID */
  id: number;
  /** 	服务商编号 */
  code: string;
  /** 服务商名称 */
  serverName: string;
  /** 是否开启(0关闭 1开启) */
  enable?: 0 | 1;
  /** 是否需要实名认证(0不需要1需要) */
  isAuth?: 0 | 1;
  /** 实名状态 0:未实名 1:已实名 */
  authStatus?: 0 | 1;
}

export interface IBindZsServerAccountParam {
  /** 服务商ID */
  serverId: number;
  /** 服务商编号 */
  serverNo: string;
  /** 服务商名称 */
  serverName: string;
  /** 招行账号 */
  bankAccount: string;
  /** 开户行 */
  openingBank: string;
  /** 分行号 */
  branchNumber: string;
}

export interface IInternalTransferParam {
  /** 服务商账号id */
  zsServerId: number;
  /** 付款方记账子单元id */
  payerUnitId: number;
  /** 收款方记账子单元id */
  payeeUnitId: number;
  /** 交易金额 */
  transferMoney: number;
  /** 交易摘要 */
  businessAbstract: string;
  /** 验证码 */
  code: string;
  /** 调账权限手机号 */
  permissionPhone: string;
}

export interface IUnitOption {
  /** 子单元表主键id */
  unitId: number;
  /** 服务商/企业/代理商名称 */
  bizName: string;
  /** 子单元编号 */
  unitNo: string;
  /** 余额 */
  balance: number;
}

export interface IZsWithdrawParams {
  /** 记账子单元id */
  unitId: number;
  /** 提现账号 */
  withdrawAccount: string;
  /** 提现金额 */
  withdrawMoney: number;
  /** 支付密码 */
  payPassword: string;
  /** 手机号 */
  payPhone: string;
  /** 验证码 */
  code: string;
}

export interface IZsWithdrawAccount {
  /** 银行名称 */
  bankName: string;
  /** 提现账号 */
  withdrawAccount: string;
  /** 记账子单元id */
  unitId: number;
}

export interface IFinanceTransactionParam extends IPageParam {
  /**
   * 交易类别
   * @description {@link EFinanceTransactionType}
  */
  fundType: EFinanceTransactionType;
  /**
   * 支付通道
   * @description {@link EPaymentChannel}
   */
  payType: EPaymentChannel;
  /** 业务线 */
  orderType: EFinanceOrderType;
  /** 交易发起方名称 */
  payerName: string;
  /** 交易接受方名称 */
  payeeName: string;
  /** 交易时间 */
  startTime: string;
  /** 交易时间 */
  endTime: string;
}

export enum EFinanceOrderType {
  /** 众包 */
  Crowd = 0,
  /** 撮合 */
  Match = 1,
  /** 公共 */
  Public = 2,
}

export const financeOrderTypeLabel = {
  [EFinanceOrderType.Crowd]: '众包灵工',
  [EFinanceOrderType.Match]: '撮合灵工',
  [EFinanceOrderType.Public]: '公共业务',
};

export const financeOrderTypeOptions = [
  {
    label: '众包灵工',
    value: EFinanceOrderType.Crowd,
  },
  {
    label: '撮合灵工',
    value: EFinanceOrderType.Match,
  },
  {
    label: '公共业务',
    value: EFinanceOrderType.Public,
  },
];

/** (RECHARGE：充值, CASH_OUT：提现, INNER_TRANSFER:内部转账, PAY：代发, REFUND:代发退款, INNER_PAY:内部代发, INNER_PAY_REFUND:内部代发退款,SERVICE:服务费) */
export enum EFinanceTransactionType {
  /** 充值 */
  RECHARGE = 'RECHARGE',
  /** 退汇 */
  REEXCHANGE = 'REEXCHANGE',
  /** 提现 */
  CASH_OUT = 'CASH_OUT',
  /** 代发 */
  TRANSFER = 'TRANSFER',
  /** 代发退款 */
  REFUND = 'REFUND',
  /** 服务费支出 */
  SERVICE_PAY = 'SERVICE_PAY',
  /** 服务费收入 */
  SERVICE_INCOME = 'SERVICE_INCOME',
  /** 服务费退款 */
  SERVICE_REFUND = 'SERVICE_REFUND',
  /** 税金支出 */
  TAX_PAY = 'TAX_PAY',
  /** 税金收入 */
  TAX_INCOME = 'TAX_INCOME',
  /** 税金退款 */
  TAX_REFUND = 'TAX_REFUND',
  /** 提现手续费退款 */
  CASH_OUT_SERVICE_REFUND = 'CASH_OUT_SERVICE_REFUND',
  /** 提现手续费 */
  CASH_OUT_SERVICE = 'CASH_OUT_SERVICE',
  /** 提现退款 */
  CASH_REFUND = 'CASH_REFUND',
  /** 自动 */
  AUTO = 'AUTO',
  /** 手工 */
  MANUAL = 'MANUAL',
  /** 内部转账 */
  INNER_TRANSFER = 'INNER_TRANSFER',
  /** 支付技术服务费 */
  TECH_SERVICE_FEE_PAY = 'TECH_SERVICE_FEE_PAY',
  /** 技术服务费退款 */
  TECH_SERVICE_FEE_REFUND = 'TECH_SERVICE_FEE_REFUND'
}

export const fundTypeLabel = {
  [EFinanceTransactionType.RECHARGE]: '充值',
  [EFinanceTransactionType.REEXCHANGE]: '退汇',
  [EFinanceTransactionType.CASH_OUT]: '提现',
  [EFinanceTransactionType.TRANSFER]: '代发',
  [EFinanceTransactionType.REFUND]: '代发退款',
  [EFinanceTransactionType.SERVICE_PAY]: '服务费支出',
  [EFinanceTransactionType.SERVICE_INCOME]: '服务费收入',
  [EFinanceTransactionType.SERVICE_REFUND]: '服务费退款',
  [EFinanceTransactionType.TAX_PAY]: '税金支出',
  [EFinanceTransactionType.TAX_INCOME]: '税金收入',
  [EFinanceTransactionType.TAX_REFUND]: '税金退款',
  [EFinanceTransactionType.CASH_OUT_SERVICE_REFUND]: '提现手续费退款',
  [EFinanceTransactionType.CASH_OUT_SERVICE]: '提现手续费',
  [EFinanceTransactionType.CASH_REFUND]: '提现退款',
  [EFinanceTransactionType.AUTO]: '自动',
  [EFinanceTransactionType.MANUAL]: '手工',
  [EFinanceTransactionType.INNER_TRANSFER]: '内部转账',
  [EFinanceTransactionType.TECH_SERVICE_FEE_PAY]: '支付技术服务费',
  [EFinanceTransactionType.TECH_SERVICE_FEE_REFUND]: '技术服务费退款',
};

export interface IFinanceTransaction {
  /** 订单号 */
  orderId: string;
  /** 交易流水号 */
  fundNo: string;
  /**
   * 交易类别
   * @description {@link EFinanceTransactionType}
  */
  fundType: EFinanceTransactionType;
  /**
   * 支付通道
   * @description {@link EPaymentChannel}
   */
  payType: EPaymentChannel;
  /** 交易发起方 */
  payerName: string;
  /** 交易发起方账号 */
  payerAccount: string;
  /** 交易接收方 */
  payeeName: string;
  /** 交易接收方账号 */
  payeeAccount: string;
  /** 交易金额 */
  fundAmount: number;
  /** 交易时间 */
  finishTime: string;
  /** 支出方向 0收入1支出) */
  inOutType: 0 | 1;
  /** 备注 */
  memo: string;
  /** 回单下载链接 */
  fileUrl?: string;
}

export const inOutTypeLabel = {
  0: '收入',
  1: '支出',
};

/** 钱包账户信息 */
export interface IFinanceWallet {
  /**
   * 用户状态
   * @description {@link EFinanceLianStatus}
   */
  userStatus: EFinanceLianStatus;
  /**
   * 账户类型
   * @description {@link EAccountType}
   */
  accountType: EAccountType;
  /** 钱包账户id（lianId/yibaoId） */
  accountId: number;
  /** 开户账号(连连编号/易宝编号) */
  accountNo: string;
  /** 开户账号(连连编号/易宝编号) */
  bankAccount: string;
  /** 企业id/代理商id */
  bizId: number;
  businessId?: number;
  /** 记账子单元的业务类型：SERVER-服务商，COMPANY-企业，AGENT-代理商 */
  bizType: 'SERVER' | 'COMPANY' | 'AGENT';
  /**
   * 通道类型
   * @description {@link EPaymentChannel}
   */
  payType: EPaymentChannel;
  /** 服务商/企业/代理商编号 */
  bizNo: string;
  /** 服务商/企业/代理商名称 */
  bizName: string;
  /** 可用余额 */
  availableBalance: number;
  /** 企业记账簿金额 */
  alipayUnitBalance: number;
  /** 可提现金额 */
  withdrawableAmount: number;
  /** 冻结余额 */
  frozenAmount: number;
  /** 服务商名称 */
  serverName: string;
  /** 服务商id */
  serverId?: number;
  /** 开户行 */
  openingBank: string;
  /** 备注 */
  remark?: string;
  /** 管理手机号 */
  regPhone?: string;
  /** 管理手机号 */
  legalPhone?: string;
  /** 开户意愿链接 */
  openAccountWillUrl?: string;
  /**
   * 签约状态
   * @description {@link ESignStatus}
   */
  signStatus?: ESignStatus;
  /** 易宝商户信息 */
  yopMerchantInfo?: IYibaoBaseInfo;
  /** 分账代理商连连账户信息 */
  airbillAgentLianInfo?: IMyWalletDetail;
  /** 分账企业连连账户信息 */
  airbillCompanyLianInfo?: IPaymentAccount;
  /** 支付宝单元银行卡列表 */
  alipayUnitBankAccountList?: [];
  /** 支付宝单元充值账号 */
  alipayRechargeAccount?: any;
}

export enum ESignStatus {
  /** 未签约 */
  NOT_SIGN = 0,
  /** 暂存 */
  TEMP = 1,
  /** 正常 */
  NORMAL = 2,
  /** 暂停 */
  STOP = 3,
}

/** 用户类型 */
export enum EUserType {
  /** 企业 */
  COMPANY = 'COMPANY',
  /** 代理商 */
  AGENT = 'AGENT',
  /** 服务商 */
  SERVER = 'SERVER',
}

/** 资金账户 - 连连账户 - 上传营业执照信息保存 */
export interface IFinanceLianLicenseParam extends ILicenseSaveParam {
  /** 企业类型 */
  type?: ECompanyType;
  /**
   * 账户类型
   * @description {@link EAccountType}
   */
  accountType: EAccountType;
  /**
   * 用户类型
   * @description {@link EUserType}
   */
  userType: EUserType;
  /** 身份证有效期开始 */
  idNoExpiryStartDate?: string;
  /** 身份证有效期结束 */
  idNoExpiryEndDate?: string;
}

export interface IFinanceLianAccOpening extends IContactPerson {
  lianId?: number;
  /**
   * 银行卡类型
   * @description {@link EBankType}
   */
  bankType?: EBankType;
  /** 银行开户许可证 */
  bankAccountOpenLicenseUrl?: string;
  /** 对公账户名 */
  bankAccountName?: string;
  /** 纳税人识别号 */
  creditCode?: string;
  /** 银行预留手机号（或个人银行卡） */
  linkedPhone?: string;
  /** 开户银行code */
  bankCode?: string;
  /** 开户银行名称（公共组件是brabankName） */
  bankName?: string;
  /** 基本账号（企业基本账号） */
  bankNo?: string;
  /** 开户省份code */
  provinceCode?: string;
  /** 开户城市code */
  cityCode?: string;
  /** 手动填写的开户支行 - 大额行号 */
  cnapsCode?: string;
  /**
   * 开户支行是否手动填写： 1-是，0-否
   */
  customStatus?: 1 | 0;

  /** 手动填写的开户支行name */
  customBankBranchName?: string;
  /** 自动匹配的开户支行name */
  relationBranchBankName?: string;
  /** 自动匹配的开户支行行号 */
  bankBranchNo?: string;
  /** 自动匹配的开户支行名称 */
  bankBranch?: string;
}

/** 用户状态 */
export enum EFinanceLianStatus {
  /** 待申请 */
  WAIT_CHECK = 'WAIT_CHECK',
  /** 审核中 */
  CHECK_PENDING = 'CHECK_PENDING',
  /** 审核失败 */
  CHECK_REJECT = 'ACTIVATE_PENDING',
  /** 待意愿确认 */
  ACTIVATE_PENDING_NEW = 'ACTIVATE_PENDING_NEW',
  /** 正常 */
  NORMAL = 'NORMAL',
  /** 取消 */
  CANCEL = 'CANCEL',
}

export const financeLianStatusLabel = {
  [EFinanceLianStatus.WAIT_CHECK]: '待申请',
  [EFinanceLianStatus.CHECK_PENDING]: '审核中',
  [EFinanceLianStatus.CHECK_REJECT]: '审核失败',
  [EFinanceLianStatus.ACTIVATE_PENDING_NEW]: '意愿确认',
  [EFinanceLianStatus.NORMAL]: '正常',
  [EFinanceLianStatus.CANCEL]: '已注销',
};

export const financeLianStatusStyle = {
  [EFinanceLianStatus.WAIT_CHECK]: 'primary',
  [EFinanceLianStatus.CHECK_PENDING]: 'primary',
  [EFinanceLianStatus.CHECK_REJECT]: 'danger',
  [EFinanceLianStatus.ACTIVATE_PENDING_NEW]: 'primary',
  [EFinanceLianStatus.NORMAL]: 'success',
  [EFinanceLianStatus.CANCEL]: 'info',
};

export interface IFinanceLianPersonal {
  /** 身份证正面 */
  idNoFrontUrl: string;
  /** 身份证反面 */
  idNoBackUrl: string;
  /** 身份证有效期开始 */
  idNoExpiryStartDate: string;
  /** 身份证有效期结束 */
  idNoExpiryEndDate: string;
  /** 用户姓名 */
  name: string;
  /**
   * 证件类型 (接口没有这个字段，前端展示用)
   * @description {@link EPayeeIdType}
   */
  idType?: EPayeeIdType;
  /** 身份证号 */
  idNo: string;
  /** 用户手机号 */
  phoneNo: string;
  /** 所在地 */
  address: string;
  /** 职业信息 */
  occupation: string;

  /** 0 法人银行卡， 1 对公 */
  licenseType?: 1 | 0;
  /** 企业-ENTERPRISE, 个体工商户-PROPRIETOR */
  formType?: ECompanyType;
}

export interface IFinanceLianPersonalParam extends IFinanceLianPersonal {
  /** 连连Id */
  lianId?: number;
  /**
   * 账户类型
   * @description {@link EAccountType}
   */
  accountType?: EAccountType;
  /**
   * 用户类型
   * @description {@link EUserType}
   */
  userType?: EUserType;
}

export interface IFinanceLianDetail extends IFinanceLianLicenseParam, ILegalPersonSaveParam, IFinanceLianAccOpening, Partial<IFinanceLianPersonal> {
  /** 受益人信息 */
  uboList: IBeneficiary[];
  /**
   * 用户状态
   * @description {@link EFinanceLianStatus}
   */
  userStatus: EFinanceLianStatus;
  /** 备注 */
  remark?: string;
  /** 银行卡号 */
  bankAccountNumber?: string;
  /** 银行预留手机号 */
  bankReservedPhone?: string;
  /** 委托代发协议号 */
  papAgreeNo?: string;

  /** 单笔限额 */
  singleLimit?: number;
  /** 单日限额 */
  dailyLimit?: number;
  /** 单月限额 */
  monthlyLimit?: number;
  /** 授权有效期开始 */
  signStartTime?: string;
  /** 授权有效期结束 */
  signInvalidTime?: string;
  /** 银行账户 */
  bankAccount?: string;
  /** 注册手机号 */
  regPhone?: string;
  /** lianlian用户编号 */
  userNo?: string;
}

/** 资金账户 - 申请linalian账户 - 验证 */
export interface IFinanceLianApplyVerify {
  /** 连连Id */
  lianId?: number;
  /** 令牌 */
  token?: string;
  /** 验证码 */
  verifyCode?: string;
  /** 支付密码 */
  password?: string;
  /** 随机因子 */
  randomKey?: string;
}

/** 资金账户 - 申请linalian账户 - 提交 */
export interface IFinanceLianApplySubmit extends IFinanceLianApplyVerify {
  /** 验证手机号 */
  regPhone?: string;
}

export interface IFinanceLianWithdraw {
  /** 连连Id */
  lianId?: number;
  /** 提现金额 */
  amount?: number;
  /** 支付密码 */
  password?: string;
  /** 随机因子 */
  randomKey?: string;
  /** 备注 */
  remark?: string;
}

/** 连连提现 - 提现2次验证 */
export interface IFinanceLianWithdrawVerify {
  /** 连连Id */
  lianId?: number;
  /** 验证码 */
  verifyCode?: string;
  /** 交易记录ID */
  txnId?: number;
  /** 令牌 */
  token?: string;
  /** 提现金额 */
  amount?: number;
}

/** 统一联账户查询请求 */
export interface IFinanceLianAccountListParam extends IPageParam {
  /**
   * 用户类型
   * @description {@link EUserType}
   */
  userType: EUserType;
  /** 名称 */
  name?: string;
  /** 编号 */
  number?: string;
  /** 注册手机号 */
  regPhone?: string;
  /**
   * 状态
   * @description {@link EFinanceLianStatus}
   */
  status?: EFinanceLianStatus;
}

/** 统一联账户列表项 */
export interface IFinanceLianAccount {
  /** lianId */
  id: number;
  /** 名称 */
  name: string;
  /** 编号 */
  number: string;
  /** 注册手机号 */
  regPhone: string;
  /** 可用金额 */
  availableAmount: number;
  /** 冻结金额 */
  frozenAmount: number;
  /** 充值总金额 */
  rechargeAmount: number;
  /** 总提现金额 */
  totalAmount: number;
  /**
   * 状态
   * @description {@link EFinanceLianStatus}
   */
  status?: EFinanceLianStatus;
}

export interface IFinanceLianBankBind {
  /** 连连账户id */
  lianId?: number;
  /** 对公账户名 */
  bankAccountName?: string;
  /** 企业用户基本户账户 */
  bankNo?: string;
  /** 银行编码 */
  bankCode?: string;
  /** 银行卡类型 */
  bankType?: EBankType;
  /** 	省编码 */
  provinceCode?: string;
  /** 市编码 */
  cityCode?: string;
  /** 对公账户开户行号/大额行号 */
  cnapsCode?: string;
  /** 对公账户开户行名 */
  bankName?: string;
  /** 开户支行名称 */
  bankBranch?: string;
  /** 支行信息是否自定义(0:否,1:是) */
  customStatus?: number;
  /** 密码 */
  password?: string;
  /** 密码随机因子key */
  randomKey?: string;
  /** 手机号 */
  linkedPhone?: string;

  [key: string]: any;
}

/** 连连账单查询参数 */
export interface IFinanceLianBillListParam extends IPageParam {
  /** 账户ID */
  lianId: number;
  /** 账户号 */
  oidAcctno?: string;
  /** 交易流水号 */
  txnSeqno?: string;
  /** 资金流水号 */
  jnoAcct?: string;
  /** 资金方向，DEBIT：出账，CREDIT：入账 */
  flagDc?: 'DEBIT' | 'CREDIT';
  /** 交易类型 */
  txnType?: EFinanceLianBillType;
  /** 创建时间(起) */
  txnTimeStart?: string;
  /** 创建时间(止) */
  txnTimeEnd?: string;
  /** 交易类别 */
  fundType?: EFinanceTransactionType;
}

/** 连连账单交易类型 */
export enum EFinanceLianBillType {
  /** 用户充值 */
  USER_TOPUP = 'USER_TOPUP',
  /** 商户充值 */
  MCH_TOPUP = 'MCH_TOPUP',
  /** 普通消费 */
  GENERAL_CONSUME = 'GENERAL_CONSUME',
  /** 担保消费 */
  SECURED_CONSUME = 'SECURED_CONSUME',
  /** 担保确认 */
  SECURED_CONFIRM = 'SECURED_CONFIRM',
  /** 内部代发 */
  INNER_FUND_EXCHANGE = 'INNER_FUND_EXCHANGE',
  /** 定向内部代发 */
  INNER_DIRECT_EXCHANGE = 'INNER_DIRECT_EXCHANGE',
  /** 外部代发 */
  OUTER_FUND_EXCHANGE = 'OUTER_FUND_EXCHANGE',
  /** 账户提现 */
  ACCT_CASH_OUT = 'ACCT_CASH_OUT',
  /** 手续费收取 */
  SERVICE_FEE = 'SERVICE_FEE',
  /** 手续费应收应付核 */
  CAPITAL_CANCEL = 'CAPITAL_CANCEL',
  /** 垫资调账 */
  ADVANCE_PAY = 'ADVANCE_PAY',
}

export const financeLianBillTypeLabel = {
  [EFinanceLianBillType.USER_TOPUP]: '用户充值',
  [EFinanceLianBillType.MCH_TOPUP]: '商户充值',
  [EFinanceLianBillType.GENERAL_CONSUME]: '普通消费',
  [EFinanceLianBillType.SECURED_CONSUME]: '担保消费',
  [EFinanceLianBillType.SECURED_CONFIRM]: '担保确认',
  [EFinanceLianBillType.INNER_FUND_EXCHANGE]: '内部代发',
  [EFinanceLianBillType.INNER_DIRECT_EXCHANGE]: '定向内部代发',
  [EFinanceLianBillType.OUTER_FUND_EXCHANGE]: '外部代发',
  [EFinanceLianBillType.ACCT_CASH_OUT]: '账户提现',
  [EFinanceLianBillType.SERVICE_FEE]: '手续费收取',
  [EFinanceLianBillType.CAPITAL_CANCEL]: '手续费应收应付核',
  [EFinanceLianBillType.ADVANCE_PAY]: '垫资调账',
};

export const financeLianBillTypeOpts = Object.entries(financeLianBillTypeLabel).map(([key, value]) => ({
  label: value,
  value: key,
}));

/** 连连账单列表项 */
export interface IFinanceLianBill {
  /** 对账单主键ID */
  billId: number;
  /** 用户类型(COMPANY:企业用户, SERVER:服务商) */
  userType: EUserType;
  /** 订单明细ID */
  orderDetailId: number;
  /** 连连账户ID */
  lianId: number;
  /** 账户号 */
  oidAcctno: string;
  /** 资金流水号 */
  jnoAcct: string;
  /** 交易流水号 */
  txnSeqno: string;
  /** ACCP系统交易单号 */
  accpTxno: string;
  /** 交易类型 */
  txnType: EFinanceLianBillType;
  /** 出入账金额 */
  amt: number;
  /** 交易后余额 */
  amtBal: number;
  /** 产品编码 */
  productCode: string;
  /** 对手账号 */
  otherAcct: string;
  /** 对手户名 */
  otherAcctName: string;
  /** 账务日期 */
  dateAcct: string;
  /** 交易时间 */
  txnTime: string;
  /** 交易发起时间 */
  transactionTime: string;
  /** 订单创建时间 */
  orderCreateTime: string;
  /** 出入账标识 */
  flagDc: 'DEBIT' | 'CREDIT';
  /** 资金流水备注 */
  memo: string;
  /** 入账方账户 */
  enterAccount: string;
  /** 入账方账户名 */
  enterAccountName: string;
  /** 出账方账户 */
  outAccount: string;
  /** 出账方账户名 */
  outAccountName: string;
  /** 处理状态 0:未完成 1：成功 */
  dealStatus: 0 | 1;
}

/** 资金账户 - 连连账户 - 修改手机号 */
export interface IFinanceLianChangePhone {
  /** 连连Id */
  lianId?: number;
  /** 新手机号 */
  regPhoneNew?: string;
  /** 支付密码 */
  password?: string;
  /** 随机因子 */
  randomKey?: string;
}

/** 资金账户 - 连连账户 - 修改支付密码 - 发送验证码 */
export interface IFinanceLianUpdatePayPassBySms {
  /** 连连Id */
  lianId?: number;
  /** 令牌 */
  token?: string;
  /** 验证码 */
  verifyCode?: string;
  /** 新支付密码 */
  password?: string;
  /** 随机因子 */
  randomKey?: string;
}

/** 资金账户 - 连连账户 - 修改支付密码 */
export interface IFinanceLianUpdatePayPass {
  /** 连连Id */
  lianId?: number;
  /** 原支付密码 */
  password?: string;
  /** 新支付密码 */
  passwordNew?: string;
  /** 随机因子 */
  randomKey?: string;
}

export const fundTypeOptMap = {
  /** 充值 */
  recharge: {
    label: '充值',
    value: EFinanceTransactionType.RECHARGE,
  },
  /** 退汇 */
  reExchange: {
    label: '退汇',
    value: EFinanceTransactionType.REEXCHANGE,
  },
  /** 提现 */
  cashOut: {
    label: '提现',
    value: EFinanceTransactionType.CASH_OUT,
  },
  /** 代发 */
  transfer: {
    label: '代发',
    value: EFinanceTransactionType.TRANSFER,
  },
  /** 代发退款 */
  refund: {
    label: '代发退款',
    value: EFinanceTransactionType.REFUND,
  },
  /** 服务费支出 */
  servicePay: {
    label: '服务费支出',
    value: EFinanceTransactionType.SERVICE_PAY,
  },
  /** 服务费收入 */
  serviceIncome: {
    label: '服务费收入',
    value: EFinanceTransactionType.SERVICE_INCOME,
  },
  /** 服务费退款 */
  serviceRefund: {
    label: '服务费退款',
    value: EFinanceTransactionType.SERVICE_REFUND,
  },
  /** 税金支出 */
  taxPay: {
    label: '税金支出',
    value: EFinanceTransactionType.TAX_PAY,
  },
  /** 税金收入 */
  taxIncome: {
    label: '税金收入',
    value: EFinanceTransactionType.TAX_INCOME,
  },
  /** 税金退款 */
  taxRefund: {
    label: '税金退款',
    value: EFinanceTransactionType.TAX_REFUND,
  },
  /** 手续费退款 */
  cashOutServiceRefund: {
    label: '手续费退款',
    value: EFinanceTransactionType.CASH_OUT_SERVICE_REFUND,
  },
  /** 提现退款 */
  cashRefund: {
    label: '提现退款',
    value: EFinanceTransactionType.CASH_REFUND,
  },
  /** 提现手续费 */
  cashOutService: {
    label: '提现手续费',
    value: EFinanceTransactionType.CASH_OUT_SERVICE,
  },

};

export const zsFundTypes = [
  {
    label: '自动',
    value: 'AUTO',
  },
  {
    label: '手工',
    value: 'MANUAL',
  },
  {
    label: '内部转账',
    value: 'INNER_TRANSFER',
  },
  {
    label: '充值',
    value: 'RECHARGE',
  },
];

const fundTypesMap = {
  [ESystemType.SAAS]: {
    [EFinanceOrderType.Crowd]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.reExchange,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.reExchange,
      ],
      [EPaymentChannel.AlipayAccountBook]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.cashOut,
        fundTypeOptMap.cashRefund,
        fundTypeOptMap.cashOutService,
        fundTypeOptMap.cashOutServiceRefund,
      ],
    },
    [EFinanceOrderType.Match]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.servicePay,
        fundTypeOptMap.serviceRefund,
        fundTypeOptMap.taxPay,
        fundTypeOptMap.taxRefund,
        fundTypeOptMap.serviceIncome,
        fundTypeOptMap.taxIncome,
        fundTypeOptMap.reExchange,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.servicePay,
        fundTypeOptMap.serviceRefund,
        fundTypeOptMap.taxPay,
        fundTypeOptMap.taxRefund,
        // 费用收入 TODO
        // 费用退款 TODO
        fundTypeOptMap.serviceIncome,
        fundTypeOptMap.taxIncome,
      ],

    },
    [EFinanceOrderType.Public]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
    },
  },
  [ESystemType.Server]: {
    [EFinanceOrderType.Crowd]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.reExchange,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.reExchange,
      ],
      [EPaymentChannel.AlipayAccountBook]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.cashOutService,
        fundTypeOptMap.cashOutServiceRefund,
      ],
    },
    [EFinanceOrderType.Match]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.refund,
        fundTypeOptMap.serviceIncome,
        fundTypeOptMap.taxIncome,
        fundTypeOptMap.serviceRefund,
        fundTypeOptMap.taxRefund,
      ],
      [EPaymentChannel.Alipay]: [
        // 费用收入 TODO
        // 费用退款 TODO
        fundTypeOptMap.serviceIncome,
        fundTypeOptMap.serviceRefund,
        fundTypeOptMap.taxIncome,
        fundTypeOptMap.taxRefund,
      ],
    },
    [EFinanceOrderType.Public]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
    },
  },
  [ESystemType.Company]: {
    [EFinanceOrderType.Crowd]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
      ],
      [EPaymentChannel.AlipayAccountBook]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.cashOut,
        fundTypeOptMap.cashRefund,
        fundTypeOptMap.cashOutService,
        fundTypeOptMap.cashOutServiceRefund,
      ],
    },
    [EFinanceOrderType.Match]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.servicePay,
        fundTypeOptMap.serviceRefund,
        fundTypeOptMap.taxPay,
        fundTypeOptMap.taxRefund,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.transfer,
        fundTypeOptMap.refund,
        fundTypeOptMap.servicePay,
        fundTypeOptMap.serviceRefund,
        fundTypeOptMap.taxPay,
        fundTypeOptMap.taxRefund,
      ],
    },
    [EFinanceOrderType.Public]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
    },
  },
  [ESystemType.Agent]: {
    [EFinanceOrderType.Crowd]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [],
      [EPaymentChannel.Alipay]: [],
    },
    [EFinanceOrderType.Match]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [],
      [EPaymentChannel.Alipay]: [],
    },
    [EFinanceOrderType.Public]: {
      [EPaymentChannel.ZS]: zsFundTypes,
      [EPaymentChannel.Lianlian]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
      [EPaymentChannel.Alipay]: [
        fundTypeOptMap.recharge,
        fundTypeOptMap.cashOut,
      ],
    },
  },
};

export function getFundTypes({
  systemType,
  orderType,
  payType,
}: {
  systemType: ESystemType;
  orderType: EFinanceOrderType;
  payType: EPaymentChannel;
}): Array<{
  label: string;
  value: EFinanceTransactionType;
}> {
  if (isNull(systemType) || isNull(orderType) || isNull(payType)) {
    return [];
  }

  return fundTypesMap[systemType][orderType][payType];
}

export interface IFinanceAgentUnit {
  id: number;
  agentName: string;
  code: string;
}

export interface ICreateUnitParam {
  bizId: number;
  bizType: string;
  bizNo: string;
  bizName: string;
  zsServerId: number;
}

export interface IZSFundParams extends IPageParam {
  /** 招商子单元Id */
  accountId: number;
  orderNo?: string;
  /**
   * 交易类别
   * @description {@link EFinanceTransactionType}
  */
  fundType?: EFinanceTransactionType;
  /** 交易发起方名称 */
  payerName?: string;
  /** 交易接受方名称 */
  payeeName?: string;
  /** 开始时间 */
  zsFundStartTime?: string;
  /** 结束时间 */
  zsFundEndTime?: string;
  /** 业务线 */
  orderType?: EFinanceOrderType;
}

export interface IZSFundItem {
  /**  */
  fundId: number;
  /** 订单ID */
  orderId: number;
  /** 订单编号 */
  orderNo: number;
  /** 交易流水号 */
  fundNo: string;
  /** 招商子单元Id */
  accountId: number;
  /** 业务线 */
  orderType: EFinanceOrderType;
  /**
   * 交易类别
   * @description {@link EFinanceTransactionType}
  */
  fundType: EFinanceTransactionType;
  /** 交易类别(RECHARGE：充值, CASH_OUT：提现,TRANSFER：代发, REFUND:代发退款) */
  fundTypeStr: string;
  /** 支出方向 0收入1支出) */
  inOutType: 0 | 1;
  /** 交易时间 */
  finishTime: string;
  /** 交易金额 */
  fundAmount: number;
  /** 交易发起方 */
  payerName: string;
  /** 交易发起方类型 SERVER-服务商，COMPANY-企业，AGENT-代理商 */
  payerType: string;
  /** 交易接受方 */
  payeeName: string;
  /** 交易接受方类型 SERVER-服务商，COMPANY-企业，AGENT-代理商 */
  payeeType: string;
  /** 交易发起方账号 */
  payerAccount: string;
  /** 交易接受方账号 */
  payeeAccount: string;
  /** 备注 */
  memo: string;
  /** 交易金额明细 */
  fundAmountDetail: string;
}

export interface IZSReceiptParams extends IPageParam {
  /** 招商子单元Id */
  accountId?: number;
}

export interface IZSReceiptItem {
  /** 回单类型：TECH_SERVICE_FEE_REFUND-技术服务费退款 */
  type?: EZSReceiptType;
  /** 金额 */
  amount?: string;
  /** 电子回单生成后的url */
  receiptUrl?: string;
  /** 关联子订单 */
  orderDetailIds?: string;
  /** receiptId */
  receiptId?: number;
}

export interface IZSReceiptForm extends IZSReceiptItem {
  /** 招商子单元Id */
  accountId?: number;
}

export enum EZSReceiptType {
  /** 技术服务费退款 */
  TECH_SERVICE_FEE_REFUND = 'TECH_SERVICE_FEE_REFUND',
}

export const zsReceiptTypeLabel = { [EZSReceiptType.TECH_SERVICE_FEE_REFUND]: '技术服务费退款' };

export interface IZSAbnormalRecordsParams extends IPageParam {
  /** 交易发起方名称 */
  payerName?: string;
  /** 交易接受方名称 */
  bizId?: string;
  /** 状态 */
  status: EZSAbnormalRecordsStatus;
  /** 处理方式 */
  handleType: EZSAbnormalRecordsMethod;
  /** 服务商名称 */
  serverName?: string;
}

export interface IZSAbnormalRecordsItem {
  /** 招商子单元Id */
  accountId: number;
  /** 交易ID */
  fundId: number;
  /** 交易时间 */
  finishTime: string;
  /** 交易金额 */
  fundAmount: number;
  /** 交易发起方 */
  payerName: string;
  /** 交易发起方类型 SERVER-服务商，COMPANY-企业，AGENT-代理商 */
  payerType: string;
  /** 交易接受方 */
  payeeName: string;
  /** 交易接受方类型 SERVER-服务商，COMPANY-企业，AGENT-代理商 */
  payeeType: string;
  /** 交易发起方账号 */
  payerAccount: string;
  /** 交易接受方账号 */
  payeeAccount: string;
  /** 交易备注 */
  memo: string;
  /** 备注 */
  handleRemark: string;
  /** 状态 */
  status: EZSAbnormalRecordsStatus;
  /** 处理方式 */
  handleType: EZSAbnormalRecordsMethod;
  /** 服务商名称 */
  serverName?: string;
}

export interface IZSAbnormalRecordsDialog {
  /** 文案 */
  message: string;
  /** 标题 */
  title: string;
  /** 处理类型 */
  handleType: EZSAbnormalRecordsMethod;
}

export enum EZSAbnormalRecordsStatus {
  /** 未处理 */
  Unprocessed = 0,
  /** 已处理 */
  Processed = 1,
}

export const zsAbnormalStatusLabel = { 
  [EZSAbnormalRecordsStatus.Unprocessed]: '未处理',
  [EZSAbnormalRecordsStatus.Processed]: '已处理', 
};

export const zsAbnormalStatusStyle = { 
  [EZSAbnormalRecordsStatus.Unprocessed]: 'danger',
  [EZSAbnormalRecordsStatus.Processed]: 'success', 
};

export enum EZSAbnormalRecordsMethod {
  /** 处理完成 */
  Processing = 'HANDLE_COMPLETED',
  /** 标记为正常充值 */
  NormalRecharge = 'MARK_NORMAL_RECHARGE',
}

export const zsAbnormalMethodLabel = { 
  [EZSAbnormalRecordsMethod.Processing]: '处理完成', 
  [EZSAbnormalRecordsMethod.NormalRecharge]: '标记为正常充值',
};

/**
 * 修改企业记账子单元名称请求参数
 */
export interface IZsUnitModifyNameRequest {
  /** 业务ID */
  bizId?: number;
  /** 业务名称 */
  bizName?: string;
}
